import styled from '@bd/bdui-styles/emotion';
import { FavoriteToggle } from '../../bdcoreCandidates/Favorites';
// import { colors } from '../../styles';

export default styled(FavoriteToggle)`
  margin: 0 auto;
  outline:none;
  &.FavoriteToggle {
    width: 30px;
    background: url(/images/icons/favorites-heart-outline.svg);
    height: 30px;
    background-repeat: no-repeat;
    transition: all .25s ease;
    background-position: left;
    &-active {
      background: url(/images/icons/favorites-heart-full.svg);
      background-repeat: no-repeat;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Favorites/FavoriteToggle.js